module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/sundance-0da3008ddc3a0adc523ec5d4dc3b5f4c.png";